module.exports = __webpack_public_path__ + "img/safe-payment-icon-navy-blue.9d059721.svg";